"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderHistoryContext = exports.OrderHistoryContextProvider = exports.OrderHistoryContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var context_1 = require("../../context/context");
var hooks_1 = require("../../hooks");
var types_1 = require("../../types");
var utils_1 = require("../../utils");
exports.OrderHistoryContext = (0, react_1.createContext)({});
var OrderHistoryContextProvider = function (_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var data = (0, hooks_1.useOrdersHistory)().data;
    var _b = (0, react_1.useState)(undefined), tab = _b[0], setTab = _b[1];
    var _c = (0, react_1.useState)(undefined), selectedOrderId = _c[0], setSelectedOrderId = _c[1];
    var isLoading = !data;
    (0, react_1.useEffect)(function () {
        if (!isOpen) {
            setTimeout(function () {
                setSelectedOrderId(undefined);
                setTab(undefined);
            }, 300);
        }
    }, [isOpen]);
    var selectOrder = (0, react_1.useCallback)(function (id) {
        setSelectedOrderId(id);
    }, [setSelectedOrderId]);
    var closePreview = (0, react_1.useCallback)(function () {
        setSelectedOrderId(undefined);
    }, [setSelectedOrderId]);
    var translations = (0, context_1.useTwapContext)().translations;
    var tabs = (0, react_1.useMemo)(function () {
        var res = (0, utils_1.mapCollection)(types_1.Status, function (it) {
            return {
                name: translations[it],
                amount: (0, utils_1.size)(data === null || data === void 0 ? void 0 : data[it]),
                key: it,
            };
        });
        res.unshift({
            name: "All",
            amount: !data ? 0 : (0, utils_1.size)(Object.values(data).flat()),
            key: undefined,
        });
        return res;
    }, [data, translations]);
    var orders = (0, react_1.useMemo)(function () {
        if (!data)
            return [];
        if (!tab) {
            return (0, utils_1.sortBy)(Object.values(data).flat(), function (it) { return it.createdAt; }).reverse();
        }
        return data[tab] || [];
    }, [data, tab]);
    var selectedTab = (0, react_1.useMemo)(function () { return tabs.find(function (it) { return it.key === tab; }); }, [tabs, tab]);
    return ((0, jsx_runtime_1.jsx)(exports.OrderHistoryContext.Provider, __assign({ value: { selectedOrderId: selectedOrderId, tabs: tabs, selectOrder: selectOrder, orders: orders, setTab: setTab, closePreview: closePreview, selectedTab: selectedTab, isLoading: isLoading } }, { children: children })));
};
exports.OrderHistoryContextProvider = OrderHistoryContextProvider;
var useOrderHistoryContext = function () {
    return (0, react_1.useContext)(exports.OrderHistoryContext);
};
exports.useOrderHistoryContext = useOrderHistoryContext;
